import React from 'react';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  searchText: {
    fontWeight: '900',
    color: '#000000',
    fontSize: '16px',
    marginBottom: '0',
  },
}));

const TableHeaderText = ({className, text, countTotal}) => {
  const classes = useStyles();
  return (
    <p className={className ? className : classes.searchText}>
      {
        text ? text : `We found "${countTotal}" result(s)`
      }
    </p>
  );
};

export default TableHeaderText;
